// ترجماتُ المجموعة 7 — تُملأ بترجمة صفحاتها (2026-10-03). المفتاح: النصُّ العربيّ كما في tt().
const EN_B7: Record<string, string> = {
  "الرحلات والتوصيل": "Trips & Dispatch",
  "رحلاتي (السائق)": "My Trips (Driver)",
  "نماذج الشركة": "Company Forms",
  "الشيكات الصادرة": "Issued Cheques",
  "تجربة الرد الذكي": "Smart Reply Lab",
  "اسم المستخدم — تقدر تدخل فيه بدل البريد": "Username — you can sign in with it instead of email",
  "أنت الآن داخل بحساب «{name}» للمعاينة — كل شيء يظهر كما يراه هو": "You're now signed in as \"{name}\" for preview — everything appears as they see it",
  "رجوع لحساب الماستر": "Back to master account",
  "{n} ساعة": "{n} hours",
  "{n} محاولة/دقيقة": "{n} attempts/min",
  "أُزيلت {n} استثناءات — عاد للدور الافتراضي": "{n} overrides removed — back to role defaults",
  "أُزيلت الاستثناءات مع التغيير": "Overrides removed with the change",
  "أُعيد {n} موظّفاً للدور الأساسي": "{n} employees reset to the base role",
  "استلام السيارة": "Car pickup",
  "الأصول (Assets)": "Assets",
  "الإجراء": "Action",
  "الإعدادات والقنوات والاشتراك": "Settings, channels & subscription",
  "الإيميلات": "Emails",
  "الاستثناءات أُبقيت كما هي": "Overrides kept as is",
  "التاريخ والوقت": "Date & time",
  "التتبع المباشر (GPS)": "Live Tracking (GPS)",
  "الدور الأساسي": "Base role",
  "الدور": "Role",
  "الرد المقترح (الذكاء المحلّي)": "Suggested reply (local AI)",
  "السائق الآخر": "Second driver",
  "السيارات والليموزين": "Cars & limousine",
  "الملاحظة": "Note",
  "الملفّات": "Files",
  "الموظّف": "Employee",
  "بحث برقم العقد أو اسم الموظف أو اسم العميل...": "Search by contract no., employee or customer name...",
  "بوت الرد الآلي": "Auto-reply bot",
  "تسليم السيارة": "Car return",
  "تعديل بيانات الدور": "Role details edited",
  "تغيّرت {n} ميزة": "{n} features changed",
  "تكامل Deema (تقسيط BNPL)": "Deema integration (BNPL installments)",
  "تم الدفع يدوياً": "Paid manually",
  "جهات الاتصال (العملاء)": "Contacts (customers)",
  "حسب الدور": "Per role",
  "حُذف الدور «{name}»": "Role \"{name}\" deleted",
  "دور جديد «{name}»": "New role \"{name}\"",
  "دور مخصص": "Custom role",
  "رفعه": "Uploaded by",
  "سماح": "Allow",
  "صندوق الوارد (الكول سنتر)": "Inbox (call center)",
  "عرض {n} من {total} سجل": "Showing {n} of {total} records",
  "فارغ": "Empty",
  "قاعدة المعرفة (للبوت)": "Knowledge base (bot)",
  "لا استثناءات لإزالتها": "No overrides to remove",
  "لا تغيير فعلي (حُفظت نفس القيم)": "No actual change (same values saved)",
  "لا تغيير فعلي": "No actual change",
  "لا توجد سجلات": "No records",
  "ملاحظة": "Note",
  "منع": "Deny",
  "نسخة من": "copy of",
  "نطاق": "Scope",
  "نظام ERP (بيانات الموظفين والمزامنة)": "ERP system (employee data & sync)",
  "نُسخت صلاحيات {name} (الدور والاستثناءات معاً)": "Copied permissions of {name} (role and overrides together)",
  "واتساب (الحسابات وربط QR)": "WhatsApp (accounts & QR linking)",
  "وحدات": "units",
  "وحدة": "unit",
  "إجمالي الفاتورة": "Invoice total",
  "إرجاع سطر إلى كشف التحصيل": "Collection row restored",
  "إرجاع صلاحيات الدور": "Role permissions restored",
  "إرجاع عمولة التوصيل": "Delivery commission restored",
  "إرجاع فيديو عقد للتعديل": "Contract video returned for edits",
  "إرسال تذكير واتساب": "WhatsApp reminder sent",
  "إضافة أصل": "Asset added",
  "إضافة جهة عمل": "Employer added",
  "إضافة سيارة": "Car added",
  "إضافة صنف للمخزون": "Stock item added",
  "إضافة عقد إلى كشف التحصيل": "Contract added to collection",
  "إضافة متابعة على عقد": "Contract follow-up added",
  "إضافة معاملة": "Errand added",
  "إضافة ورقة شركة": "Company document added",
  "إضافة وسائط للسيارة": "Car media added",
  "إعادة إرسال فيديو عقد": "Contract video resubmitted",
  "إعادة فتح عقد (Drive8)": "Contract reopened (Drive8)",
  "إعادة محادثة بعد فك الربط": "Conversation restored after unlink",
  "إلغاء تفويض إنستغرام (Meta)": "Instagram deauthorized (Meta)",
  "إلغاء حجز": "Booking cancelled",
  "إلغاء عقد تأجير": "Rental contract cancelled",
  "إلغاء عمولة التوصيل": "Delivery commission voided",
  "إنجاز متابعة": "Follow-up completed",
  "إنشاء حجز": "Booking created",
  "إنشاء دور": "Role created",
  "إنشاء عقد تأجير": "Rental contract created",
  "استلام بضاعة للمخزون": "Stock received",
  "اعتماد فيديو عقد وإرساله": "Contract video approved & sent",
  "التصنيف": "Category",
  "التعديل": "Edit",
  "التنبيه قبل (يوم)": "Remind before (days)",
  "الجهة": "Authority",
  "الحدّ الأدنى": "Minimum",
  "الحذف": "Delete",
  "الحقول المعدَّلة": "Changed fields",
  "الرصيد الافتتاحي": "Opening balance",
  "الرف": "Shelf",
  "الصنف": "Item",
  "العرض": "View",
  "الفارق": "Difference",
  "الكمية المعدودة": "Counted quantity",
  "الكمية وقت الحذف": "Quantity at deletion",
  "المعاملة": "Errand",
  "المكان": "Location",
  "الملف": "File",
  "المورّد": "Supplier",
  "الموظّف الموكَّل": "Assigned employee",
  "الموعد": "Due date",
  "انتهاء الكفالة": "Warranty expiry",
  "بالساعة": "Hourly",
  "باليوم": "Daily",
  "تأكيد حجز": "Booking confirmed",
  "تاريخ الفاتورة": "Invoice date",
  "تسجيل صيانة سيارة": "Car service logged",
  "تعديل أصل": "Asset edited",
  "تعديل إعدادات تنبيهات الصيانة": "Maintenance alert settings edited",
  "تعديل السائق الآخر": "Second driver edited",
  "تعديل جهة عمل": "Employer edited",
  "تعديل جهة عمل العميل": "Customer employer edited",
  "تعديل دور": "Role edited",
  "تعديل سطر كشف التحصيل": "Collection row edited",
  "تعديل سيارة": "Car edited",
  "تعديل صلاحيات موظّف": "Employee permissions edited",
  "تعديل صنف في المخزون": "Stock item edited",
  "تعديل عقد تأجير": "Rental contract edited",
  "تعديل محصِّل العميل": "Customer collector edited",
  "تعديل مصفوفة دور": "Role matrix edited",
  "تعديل معاملة": "Errand edited",
  "تعديل موعد السداد لهذا الشهر": "This month's payment date edited",
  "تعديل هدف الشهر": "Monthly target edited",
  "تعديل/تجديد ورقة شركة": "Company document edited/renewed",
  "تغيير دور موظّف": "Employee role changed",
  "جرد/تسوية مخزون": "Stock count/adjustment",
  "حذف أصل": "Asset deleted",
  "حذف بيانات إنستغرام (Meta)": "Instagram data deleted (Meta)",
  "حذف دور": "Role deleted",
  "حذف رابط الدفع": "Payment link deleted",
  "حذف سطر من كشف التحصيل": "Collection row removed",
  "حذف سيارة": "Car deleted",
  "حذف صنف من المخزون": "Stock item deleted",
  "حذف عقد تأجير": "Rental contract deleted",
  "حذف فاتورة أصل": "Asset invoice deleted",
  "حذف معاملة": "Errand deleted",
  "حذف ورقة شركة": "Company document deleted",
  "حذف وسائط من السيارة": "Car media deleted",
  "حركات محفوظة": "Saved movements",
  "دفع مكتمل": "Payment completed",
  "ربط حساب إنستغرام": "Instagram account connected",
  "ربط رقم بعقد": "Number linked to contract",
  "رفض ربط حساب إنستغرام": "Instagram connection refused",
  "رفض فيديو عقد": "Contract video rejected",
  "رفع فاتورة أصل": "Asset invoice uploaded",
  "رفع فيديو عقد": "Contract video uploaded",
  "رقم الأصل": "Asset no.",
  "رقم الصنف": "Item no.",
  "رقم الفاتورة": "Invoice no.",
  "رقم الورقة": "Document no.",
  "سعر الشراء": "Purchase price",
  "عدد الأصناف": "Items count",
  "غير متاحة": "Unavailable",
  "غير مدفوع": "Unpaid",
  "فصل حساب إنستغرام": "Instagram account disconnected",
  "فك ربط رقم عميل": "Customer number unlinked",
  "قيد الانتظار": "Pending",
  "قيمة المخزون": "Stock value",
  "متوسّط التكلفة": "Average cost",
  "مدير النظام": "System admin",
  "مزامنة بيانات": "Data sync",
  "مسح التاريخ": "Clear dates",
  "نسخ صلاحيات موظّف": "Employee permissions copied",
  "يناسب": "Fits",
  "⚠️ اعتماد لم يصل العميل": "⚠️ Approval didn't reach customer",
  "⚠️ محاولات مزامنة مفرطة": "⚠️ Excessive sync attempts",
  "⚠️ محاولات مزامنة مفرطة (حظر مؤقت)": "⚠️ Excessive sync attempts (temporary block)",
  "إجمالي التعاملات": "Total dealings",
  "إجمالي الصرف": "Total spend",
  "العقد النشط": "Active contract",
  "العقد النشط (Drive8)": "Active contract (Drive8)",
  "آخر تواصل": "Last contact",
  "درجة اتصال سيارته": "Car connectivity score",
  "اللوحة": "Plate",
  "المدة": "Period",
  "بداية العقد": "Contract start",
  "رقم الليسن": "License no.",
  "{n} سيارات": "{n} cars",
  "اضغط «ولّد الملخص» ليقرأ Jisr AI كامل تاريخ العميل ويكتب خلاصة عملية للموظف.": "Press \"Generate summary\" so Jisr AI reads the customer's full history and writes a practical brief for staff.",
  "الاسم من الأسطول": "Name from fleet",
  "الاسم من السيارة المؤجَّرة له في نظام التأجير": "Name taken from the car rented to them in the rental system",
  "الاسم والعقد ورقم الليسن تُقرأ من السيارة المؤجَّرة له في نظام التأجير، وتتحدّث كل خمس دقائق.": "Name, contract and license no. are read from the car rented to them in the rental system, refreshed every five minutes.",
  "البطارية الداخلية": "Internal battery",
  "البطاقة المدنية": "Civil ID",
  "الرخصة": "License",
  "السيارة الآن": "Car now",
  "العميل غير مرتبط بملف Drive8 — افتح ملف ERP واربطه": "Customer isn't linked to a Drive8 record — open the ERP record and link it",
  "المستندات والمرفقات": "Documents & attachments",
  "المصدر الموثوق": "source of truth",
  "النشاط الموحد": "Unified activity",
  "اليوم {n}": "day {n}",
  "تتحرك {n} كم/س": "Moving {n} km/h",
  "تجاوزات السرعة": "Speed violations",
  "تشغيل التسجيل": "Play recording",
  "تعذّر جلب التسجيل": "Couldn't fetch the recording",
  "تنتهي خلال {n} يوم": "expires in {n} days",
  "جاري تحميل ملف العميل...": "Loading customer profile...",
  "جارٍ التحليل...": "Analyzing...",
  "جارٍ جلب التسجيل من البدالة…": "Fetching recording from the PBX…",
  "حدّث": "Refresh",
  "درجة الاتصال": "Connectivity",
  "رخصة القيادة": "Driving license",
  "سارية حتى": "Valid until",
  "عدد عقوده في نظام التأجير": "Number of their contracts in the rental system",
  "عقد نشط {i} من {n}": "Active contract {i} of {n}",
  "عقود وحجوزات": "Contracts & bookings",
  "عميل متكرر · {n} تعامل": "Repeat customer · {n} dealings",
  "غير مرتبط": "Not linked",
  "غير معروف": "unknown",
  "فتح المحادثة": "Open chat",
  "فتح المرفق": "Open attachment",
  "فتح في التتبع الحي": "Open in Live Tracking",
  "فشل التحميل": "Failed to load",
  "فشل التوليد": "Generation failed",
  "قائمة العملاء": "Customer list",
  "قبل {n} د": "{n} min ago",
  "قبل {n} س": "{n} h ago",
  "قبل {n} يوم": "{n} days ago",
  "كل شي بترتيب زمني واحد": "Everything in one timeline",
  "كهرباء الجهاز مفصولة": "Device power disconnected",
  "لا سيارة مؤجَّرة لهذا الرقم": "No car rented to this number",
  "لا سيارة مؤجَّرة لهذا الرقم حالياً": "No car currently rented to this number",
  "لا مرفقات بعد — الصور والملفات من محادثاته تظهر هنا تلقائياً": "No attachments yet — images and files from their chats appear here automatically",
  "لا مصدرَ لعدد التعاملات عند هذه الشركة — لا حجوزات في جسر ولا مرآة Drive8": "No source for the dealings count at this company — no Jisr bookings and no Drive8 mirror",
  "لا يوجد عقد إيجار نشط حالياً": "No active rental contract right now",
  "لا يوجد نشاط من هذا النوع": "No activity of this type",
  "لم يُولَّد بعد": "Not generated yet",
  "ليسن": "License",
  "ما زال يُحسب — حدّث الصفحة بعد قليل.": "Still processing — refresh the page shortly.",
  "ما في جهاز تتبع مربوط بسيارة هذا العميل": "No tracking device linked to this customer's car",
  "مدفوعات": "Payments",
  "مدني": "Civil ID",
  "مرتبط": "Linked",
  "مزامنة الأنظمة": "System sync",
  "مستندات": "Documents",
  "مكالمات": "Calls",
  "ملخص Jisr AI": "Jisr AI summary",
  "ملف": "File",
  "منتهية": "Expired",
  "منتهية!": "expired!",
  "منقطعة — آخر إرسال {t}": "Offline — last report {t}",
  "موقع التجاوز": "Violation location",
  "نظام التأجير (المصدر الموثوق)": "Rental system (source of truth)",
  "نواقص بيانات العميل تتعبّى وتُصحّح تلقائياً من Drive8 — إدارتها من ملف ERP في صفحة العملاء.": "Missing customer data is filled and corrected automatically from Drive8 — manage it from the ERP record on the Customers page.",
  "واقفة": "Parked",
  "ولّد الملخص": "Generate summary",
  "{d} يوم من {n}": "{d} of {n} days",
  "اختر نموذجاً": "Choose a form",
  "جاهز": "Built-in",
  "نموذج جديد": "New form",
  "تعديل النموذج": "Edit form",
  "حذف النموذج": "Delete form",
  "نموذج جاهز — لا يُعدَّل ولا يُحذف": "Built-in form — can't be edited or deleted",
  "ابحث برقم العقد أو اسم المستأجر أو المدنيّ أو اللوحة…": "Search by contract no., renter name, civil ID or plate…",
  "لا نتائج": "No results",
  "اختر عقداً لتعبئة النموذج": "Pick a contract to fill the form",
  "تغيير العقد": "Change contract",
  "مُقفل": "Closed",
  "البيانات": "Data",
  "مُعبَّأةٌ من المصدر — صحّح ما يلزم قبل الطباعة": "Filled from the source — correct anything needed before printing",
  "الموظف": "Employee",
  "ابحث برقم الموظف أو اسمه أو المدنيّ…": "Search by employee no., name or civil ID…",
  "اختر موظفاً من ERP لتعبئة النموذج": "Pick an ERP employee to fill the form",
  "تغيير الموظف": "Change employee",
  "لا نتائج — هل بيانات الموظفين مُزامنة من ERP؟": "No results — is employee data synced from ERP?",
  "حقل بلا قيمة — سيُطبع خانةً فارغة": "Field has no value — it will print blank",
  "{n} حقلاً بلا قيمة — ستُطبع خانةً فارغة": "{n} fields have no value — they will print blank",
  "— اختر —": "— Choose —",
  "متغيّرات غير معروفة في النموذج": "Unknown variables in the form",
  "معاينة النصّ": "Preview text",
  "اطبع الورقة": "Print document",
  "جارٍ التجهيز…": "Preparing…",
  "هويّة الشركة غير مضبوطة — املأ «هويّة الشركة» في الإعدادات، وإلّا لن تُطبع الورقة": "Company identity isn't set — fill in \"Company Identity\" in Settings, or the document won't print",
  "طُبعت بلا شعار — اسم الشركة نصّاً في الترويسة": "Printed without a logo — company name as text in the header",
  "شعار الترويسة": "Header logo",
  "المعرّف": "Identifier",
  "حروف إنجليزيّة صغيرة وأرقام وشرطات — يدخل في الرابط ولا يتغيّر بعد الحفظ": "Lowercase English letters, numbers and dashes — used in the link and can't change after saving",
  "نصّ النموذج": "Form text",
  "يُملأ من عقد تأجير": "Filled from a rental contract",
  "سطر يبدأ بـ«## » عنوانٌ في الوسط · سطر يبدأ بـ«> » سطرُ توقيع · سطر فارغ فاصلُ فقرة": "A line starting with \"## \" is a centered heading · a line starting with \"> \" is a signature line · a blank line separates paragraphs",
  "المتغيّرات — انقر لإدراجه في النصّ": "Variables — click to insert into the text",
  "جارٍ الحفظ…": "Saving…",
  "لا توجد نماذج بعد": "No forms yet",
  "حذف نموذج «{t}»؟ لا يمكن التراجع.": "Delete form \"{t}\"? This can't be undone.",
  "تعذّر الحذف": "Couldn't delete",
  "تعذّرت الطباعة": "Couldn't print",
  "تعذّر الحفظ": "Couldn't save",
  "أُرسل التذكير إلى {to} — الرقم {from} ليس عليه واتساب": "Reminder sent to {to} — number {from} has no WhatsApp",
  "الإجماليّ ({n})": "Total ({n})",
  "الكشف": "Statement",
  "اليوم التالي": "Next day",
  "اليوم السابق": "Previous day",
  "بدأ": "started",
  "بعد استبعاد {n} عقد": "after excluding {n} contracts",
  "بلا عقد": "No contract",
  "خارجه": "outside",
  "رابط دفع": "Payment link",
  "سند": "receipts",
  "لا توجد بيانات في هذه الفترة": "No data in this period",
  "محفوظٌ ولا يُستعمل في النمط اليدويّ": "saved but not used in manual mode",
  "مرجع": "Ref",
  "مستبعَد": "excluded",
  "مشوار {n} (موعده {d})": "Trip {n} (scheduled {d})",
  "و{n} سند نشاطٍ آخر (اوبر وكريم) بمبلغ {kd} د.ك — خارج التحصيل تماماً، فيفترق مجموعُ الشهر عن تقرير القبض بهذا القدر.": "Plus {n} other-activity receipts (Uber & Careem) totaling {kd} KD — entirely outside collection, so the month total differs from the receipts report by this amount.",
  "يساوي «إجمالي المقبوض» في تقرير القبض لنفس الشهر": "equals \"Total received\" in the receipts report for the same month",
  "+ جهةٌ جديدة…": "+ New employer…",
  "آخر تذكير": "Last reminder",
  "آخر سند": "Last receipt",
  "أبريل": "April",
  "أخرى": "Other",
  "أرفق رابط دفعٍ بالمتبقّي": "Attach a payment link for the remaining amount",
  "أرفق رابط دفعٍ بالمتبقّي في كلّ رسالة": "Attach a payment link for the remaining amount in each message",
  "أسماءٌ محذوفة من الكشف": "Names removed from the statement",
  "أضف": "Add",
  "أضف إلى الكشف": "Add to statement",
  "أغسطس": "August",
  "أقفلها Drive8 (أو أُرجعت سيّارتُها) ولا مبلغَ عليها ولا لها، ولم يُقبَض منها شيءٌ هذا الشهر — فلا تدخل الكشفَ ولا حساباته. العقدُ الذي بقي فيه مبلغٌ يظهر بمتبقّيه، والذي قُبض منه في الشهر يظهر بقبضه.": "Closed by Drive8 (or the car was returned) with nothing owed either way, and nothing received this month — so they're excluded from the statement and its totals. A contract with a remaining amount shows with its balance, and one with receipts this month shows with its receipts.",
  "أكتوبر": "October",
  "أكملوا الدفع": "Paid in full",
  "أهداف الشهر": "Monthly targets",
  "أهدافُ الفرعين القديمة": "Old branch targets",
  "أُرسل التذكير": "Reminder sent",
  "أُضيف يدويّاً": "Added manually",
  "أُنجز": "Done",
  "إجماليّ مقبوضات الشهر": "Total receipts this month",
  "إخفاء": "Hide",
  "إرسال إلى": "Send to",
  "إزالة الاستثناء": "Remove exception",
  "إضافة عقد إلى الكشف": "Add contract to statement",
  "إضافة عقد إلى كشف هذا الشهر": "Add a contract to this month's statement",
  "إضافة متابعة": "Add follow-up",
  "إعادة إلى الكشف": "Restore to statement",
  "إلغاء التحديد": "Clear selection",
  "إلغاء الفلتر": "Clear filter",
  "إلغاء القانونيّة": "Remove legal status",
  "إيقاف بعد الحاليّ": "Stop after current",
  "اتّصال": "Call",
  "اربط بمتابعة": "Link to follow-up",
  "استثناءٌ لشهرٍ واحد فوق الجدول — الشهرُ التالي يعود إلى الجدول": "A one-month exception over the schedule — next month returns to the schedule",
  "اسم جهة العمل الجديدة:": "New employer name:",
  "اضبط الهدف": "Set target",
  "الأرصدة": "Balances",
  "الإجراء التالي": "Next action",
  "الإرسال من حساب": "Send from account",
  "الجهة بلا يوم صرف — اضبطه من هنا ويسري على كلّ عملائها من هذا الشهر": "Employer has no payday — set it here and it applies to all its customers from this month",
  "الرسالة": "Message",
  "الرصيد الافتتاحيّ": "Opening balance",
  "الرصيد الختاميّ": "Closing balance",
  "السبب (اختياري)": "Reason (optional)",
  "الشهر": "Month",
  "الفرع": "Branch",
  "القائمة الرئيسية": "Main menu",
  "القائمة من الكشف المعروض (بفلاترك الحاليّة): كلّ من موعده المكتوب حلّ أو مضى وعليه متبقّ. راجعها، ثمّ إرسال واحد يرسل لكلّ محدَّد على التوالي — لا شيء يُرسَل آليّاً.": "The list comes from the displayed statement (with your current filters): everyone whose recorded due date has arrived or passed and still owes. Review it, then one Send messages each selected person in turn — nothing is sent automatically.",
  "القسط": "Installment",
  "القسط: الشهريّ قسطُ شهرٍ واحد (السعر + السائق أو القسطُ المكتوب)، واليوميّ قيمتُه كاملةً في شهرِ بدايته. المتأخّرات: ما استُحقّ في الأشهر السابقة ولم يُدفع (وسالبُها رصيدٌ مقدَّم). المستحقّ الكلّي = القسط + المتأخّرات. المحصَّل من سندات القبض المطابقة للعقد والفرع معاً.": "Installment: monthly = one month's installment (price + driver, or the recorded installment); daily = its full value in its start month. Arrears: what fell due in previous months and wasn't paid (negative = prepaid credit). Total due = installment + arrears. Collected = receipts matching both contract and branch.",
  "القسم": "Segment",
  "القسمُ هنا «يومي» وDrive8 يقول إنّ العقدَ شهريّ — فلا يُحمَّل قسطاً إلّا في شهر بدايته، وسنداتُه تُقرأ رصيداً مقدَّماً. اضبط القسمَ «شهري» ليقرأ أجرةَ الشهر من Drive8.": "The segment here is \"Daily\" but Drive8 says the contract is monthly — so it's charged an installment only in its start month and its receipts read as prepaid credit. Set the segment to \"Monthly\" to read the monthly rent from Drive8.",
  "الكلّ": "All",
  "الليموزين (سندات القبض في الشهر)": "Limousine (receipts this month)",
  "المتأخّر": "Overdue",
  "المتأخّرات": "Arrears",
  "المتبقّي للهدف": "Remaining to target",
  "المحصَّل": "Collected",
  "المحصَّل اليوم": "Collected today",
  "المحصَّل اليوميّ": "Daily collection",
  "المحصِّل": "Collector",
  "المستحقّ": "Due",
  "المستحقّ الكلّي": "Total due",
  "المصدر": "Source",
  "المطلوب للهدف": "Needed for target",
  "الملاحظةُ لا تغيّر الرصيد — «مدفوع» لا يُكتب إلا من سند قبض": "A note doesn't change the balance — \"paid\" is only recorded from a receipt",
  "النتيجة": "Outcome",
  "الهدف": "Target",
  "الهدف المشترك السابق": "Previous combined target",
  "الوقت": "Time",
  "اليوم (١–٣١)": "Day (1–31)",
  "انتهاء العقد": "Contract end",
  "انتهاء العقد (من Drive8)": "Contract end (from Drive8)",
  "انتهاء عقد": "Contract ending",
  "انتهاء عقد — تمديد أم تسليم؟": "Contract ending — extend or return?",
  "انتهى": "Finished",
  "انتهى منذ": "Ended",
  "بتاريخ": "On date",
  "بحث: اسم / عقد / سيارة": "Search: name / contract / car",
  "بدأ في هذا الشهر (تاريخ بداية العقد في Drive8)": "Started this month (contract start date in Drive8)",
  "بدأ هذا الشهر": "Started this month",
  "بلا تسجيل": "No recording",
  "بلا رقم": "No number",
  "بلا محصِّل": "No collector",
  "بلا موعد — عليه مبلغ": "No date — amount owed",
  "تحديد الكلّ": "Select all",
  "تحقّق الهدف": "Target reached",
  "تحويل إلى قانونيّة": "Mark as legal",
  "تذكير": "Remind",
  "تذكير جماعيّ": "Bulk reminder",
  "تذكير جماعيّ — حلّ موعدهم ولم يدفعوا": "Bulk reminder — due and unpaid",
  "تذكيرُ واتساب": "WhatsApp reminder",
  "ترتيب الورقة": "Sheet order",
  "تصدير CSV": "Export CSV",
  "تعذّر التحميل": "Couldn't load",
  "تفاصيل": "Details",
  "تم الدفع": "Paid",
  "تمديد أم تسليم؟": "Extend or return?",
  "تملك": "Ownership",
  "تمّ": "Done",
  "ثلاثةُ أهداف: التحصيل والتأجير الجديد (كلاهما للفرعين معاً — قرار المالك) والليموزين. لا تُقسَّم على الفروع ولا الموظّفين": "Three targets: collection and new rentals (both for both branches together — owner's decision) and limousine. Not split across branches or employees",
  "جارٍ الإرسال…": "Sending…",
  "جديدة هذا الشهر": "New this month",
  "جديدة — لم تُصنَّف": "New — unclassified",
  "جزء": "Partial",
  "جهة العمل": "Employer",
  "حجوزات الشهر (بتاريخ الحجز)": "Month's bookings (by booking date)",
  "حذف من الكشف": "Remove from statement",
  "حساب الإرسال لفرع": "Sending account for branch",
  "حسب المكتب": "By office",
  "حسب تاريخ القبض (الأحدث أوّلاً)": "By receipt date (newest first)",
  "حسب تاريخ القبض (الأقدم أوّلاً)": "By receipt date (oldest first)",
  "حسب طريقة الدفع": "By payment method",
  "حلّ موعدهم": "Due now",
  "حُفظ": "Saved",
  "دفعة": "Payment",
  "دفعوا شيئاً": "Paid something",
  "ديسمبر": "December",
  "دينٌ سابقٌ لبداية الدفتر سُدِّد هذا الشهر (العقدُ مُقفل)": "Pre-ledger debt settled this month (contract closed)",
  "ذُكِّر اليوم — غير محدَّد": "Reminded today — not selected",
  "ردّ": "Answered",
  "رصيدٌ مقدَّم": "Prepaid credit",
  "رفض": "Refused",
  "رقم السند": "Receipt no.",
  "رقمٌ خاطئ": "Wrong number",
  "زيارة": "Visit",
  "سبب حذف هذا الاسم من الكشف (يُقرأ لاحقاً):": "Reason for removing this name from the statement (kept for later):",
  "سببُ الإضافة (يُقرأ لاحقاً):": "Reason for adding (kept for later):",
  "سبتمبر": "September",
  "سجلّ التذكيرات": "Reminder history",
  "سجلّ المتابعة": "Follow-up log",
  "سطرٌ إضافيّ يُلحَق بكلّ رسالة (اختياري)": "Extra line appended to each message (optional)",
  "سطرٌ لكلّ عقدٍ جارٍ في الشهر — المستحقّ من العقد، والمحصَّل من سندات القبض، والمتبقّي محسوب": "One row per active contract in the month — due from the contract, collected from receipts, remaining calculated",
  "سند قبض هذا الشهر": "Receipt this month",
  "سندات الليموزين في الشهر": "Limousine receipts this month",
  "سنداتٌ في الشهر لا تطابق عقداً جارياً (بلا رقم عقد، أو عقدٌ مُقفلٌ قبل الشهر) — تُعرض كي يطابق مجموعُ الشهر تقريرَ القبض.": "Receipts this month that don't match an active contract (no contract number, or a contract closed before the month) — shown so the month total matches the receipts report.",
  "سنداتُ القبض في الشهر من مكتب الليموزين في Drive8 (موقع ٣) — لا مشاويرُ الشهر ولا عربونُها المدفوع في أشهرٍ سابقة": "This month's receipts from the limousine office in Drive8 (location 3) — not this month's trips nor deposits paid in earlier months",
  "سندُ قبضٍ بلا عقدٍ في Drive8 — صفٌّ في الكشف بسنده: مستحقُّه ما قُبض، بلا متبقٍّ ولا تذكير.": "A receipt with no contract in Drive8 — a statement row by its receipt: due equals what was received, no remaining and no reminder.",
  "سنوي": "Yearly",
  "شهرٌ مضى — الموعدُ المجمَّد لا يتغيّر بتغيير الجدول؛ استعمل موعدَ الشهر الخاصّ": "A past month — the frozen date doesn't change with the schedule; use the month-specific date",
  "صادرة": "Outbound",
  "صفوفُ ورقة المحاسب وحدَها وبترتيبها؛ ما عداها من العقود الجارية في Drive8 يظهر في «كلّ العقود الجارية»": "Only the accountant's sheet rows, in their order; other active Drive8 contracts appear under \"All active contracts\"",
  "ضبط يوم صرف الجهة": "Set employer payday",
  "طابور اليوم": "Today's queue",
  "عدد السندات": "Receipts count",
  "عرض المرشّحين": "Show candidates",
  "عرضٌ فقط، ليست تحصيلاً": "Display only, not collection",
  "عقداً جديداً · قيمتها التعاقديّة": "new contracts · contract value",
  "عقدٌ أقفله Drive8 وما زال يُحصَّل عليه (تملّك/سنوي) — اكتب رقمه كاملاً واختر فرعه وقسمه": "A contract Drive8 closed that's still being collected (ownership/yearly) — enter its full number and choose its branch and segment",
  "عقدٌ من Drive8 ليس في الكشف — يُضاف بيدٍ وسبب ويُسجَّل. الأرشيفُ لا يدخل من نفسه أبداً.": "A Drive8 contract not in the statement — added manually with a reason and logged. Archived contracts never enter on their own.",
  "عقودٌ جارية في Drive8 ليست في الكشف": "Active Drive8 contracts not in the statement",
  "عقودٌ جديدة": "New contracts",
  "عقودٌ حيّة في Drive8 استُبعدت بيدٍ وسبب — لا تدخل الحساباتِ ولا الإحصائيّات ولا «خارج الكشف»؛ تُعاد من هنا.": "Live Drive8 contracts excluded manually with a reason — not counted in totals, stats or \"outside the statement\"; restore them from here.",
  "عقودٌ شهريّة جارية في Drive8 ليست في دفتر التحصيل بعد. اختر قسمَها لتدخل الكشف، أو احذفها.": "Active monthly Drive8 contracts not yet in the collection book. Choose a segment to add them to the statement, or remove them.",
  "عقودٌ مُقفلة بلا رصيدٍ ولا قبضٍ في الشهر — لا تظهر في الكشف": "Closed contracts with no balance and no receipts this month — not shown in the statement",
  "عقودُ الشهر": "This month's contracts",
  "عليهم متأخّرات": "Have arrears",
  "عليهم مستحقّ": "Have amount due",
  "فبراير": "February",
  "فلتر البطاقة": "Card filter",
  "قال إنّه دفع (يُثبت بسند)": "Claims paid (needs a receipt)",
  "قانونيّة": "Legal",
  "قبول كـ": "Accept as",
  "قديمة": "Old",
  "قسط": "Installment",
  "قيمةُ العقود الجديدة (تعاقديّة، لا نقد)": "New contracts value (contractual, not cash)",
  "كشف الشهر": "Monthly statement",
  "كلّ العقود الجارية": "All active contracts",
  "لا أحدَ حلّ موعده ولم يدفع في الكشف المعروض.": "No one in the displayed statement is due and unpaid.",
  "لا جهةَ عملٍ بيوم صرف ولا يومٌ ثابت — اكتب الاتّفاق مع الزبون؛ لا يُخمَّن من بداية العقد ولا من السندات": "No employer payday and no fixed day — record the agreement with the customer; it's not guessed from the contract start or receipts",
  "لا حساب واتساب مفعّلاً": "No active WhatsApp account",
  "لا ردّ": "No answer",
  "لا رقمَ لهذا العميل في Drive8": "No number for this customer in Drive8",
  "لا سندات قبض في هذا اليوم.": "No receipts on this day.",
  "لا سندَ قبضٍ من مكتب الليموزين في هذا الشهر.": "No receipts from the limousine office this month.",
  "لا عقودَ جاريةً في هذا الشهر.": "No active contracts this month.",
  "لا متابعةَ بعد": "No follow-ups yet",
  "لا مكالماتَ لأرقام هذا العميل": "No calls for this customer's numbers",
  "لا موعد": "No date",
  "لا موعدَ مكتوباً — اكتبه من الاتّفاق مع الزبون": "No date recorded — enter it from the agreement with the customer",
  "لم يدفعوا · أو عقدٌ يوميّ انتهى": "Unpaid · or a daily contract ended",
  "لم يكملوا الدفع": "Not fully paid",
  "لم يُحدَّد": "Not set",
  "لم يُحدَّد هدفٌ لهذا الشهر": "No target set for this month",
  "لم يُدفع": "Unpaid",
  "لم يُدفع بعد": "Not paid yet",
  "لم يُرسل": "Not sent",
  "لم يُرسل تذكيرٌ لهذا العقد بعد": "No reminder sent for this contract yet",
  "مارس": "March",
  "مايو": "May",
  "متأخّر": "Overdue",
  "متابعاتي": "My follow-ups",
  "مثال: يمكنكم السداد في الفرع أو عبر رابط الدفع": "e.g. You can pay at the branch or via the payment link",
  "مجموع الهدفين": "Sum of both targets",
  "مجموعُها مقترَحٌ لهدف التأجير": "Their sum is suggested as the rental target",
  "محصَّلٌ من القديمة": "Collected from old",
  "محصَّلٌ منها": "Collected from them",
  "محصَّلُ الفرعين": "Both branches collected",
  "مرحَّل": "Carried over",
  "مساهمة": "Contribution of",
  "معاودة اتّصال": "Call back",
  "مقبوضاتٌ خارج الكشف": "Receipts outside the statement",
  "مقبوضٌ قبل بداية الدفتر": "Received before ledger start",
  "مقبوضٌ قبل بداية الدفتر (يُقرأ رصيداً افتتاحيّاً)": "Received before ledger start (read as opening balance)",
  "مقترَحٌ من الشهر السابق": "Suggested from last month",
  "مكالماتُ أرقام هذا العميل في البدالة (بصلاحيّة صندوق الوارد)": "PBX calls for this customer's numbers (requires Inbox permission)",
  "مكالماتُ البدالة": "PBX calls",
  "ملاحظة القضيّة (اختياري):": "Case note (optional):",
  "من العقود القائمة": "From existing contracts",
  "من الهدف": "of target",
  "من لم يُقبض منه شيءٌ هذا الشهر يأتي بعد المقبوض": "Those with no receipts this month come after those paid",
  "من موعدُه اليوم أو مضى: قسطٌ حلّ ولم يُدفع، عقدٌ يوميّ بلغ انتهاءه، وعدٌ بالسداد. الكشفُ الشهريّ لا يتغيّر — هذا عرضٌ فقط.": "Those due today or earlier: an installment due and unpaid, a daily contract that reached its end, a promise to pay. The monthly statement doesn't change — this is a view only.",
  "موعد السداد الفعليّ لهذا الشهر — من جهة العمل أو يومٍ ثابت أو استثناءِ الشهر": "Actual payment date this month — from the employer, a fixed day or a month exception",
  "موعد سداد": "Payment due",
  "موعدٌ خاصّ بهذا الشهر": "Date specific to this month",
  "موعدٌ لهذا الشهر": "Date for this month",
  "موعدُ الإجراء التالي": "Next action date",
  "مُقفل في Drive8 — يبقى في الكشف بقسمه": "Closed in Drive8 — stays in the statement under its segment",
  "نسبة التحصيل": "Collection rate",
  "نمطُ الموعد": "Date mode",
  "نوعه": "Type",
  "نوفمبر": "November",
  "هدف التأجير (الفرعان معاً)": "Rental target (both branches)",
  "هدف التأجير الجديد": "New rentals target",
  "هدف التحصيل": "Collection target",
  "هدف الليموزين": "Limousine target",
  "هدفُ التأجير الواحد قبل قسمته — اضبط الهدفين ليحلّا محلّه": "The single rental target before it was split — set both targets to replace it",
  "واردة": "Inbound",
  "ورقة المحاسب": "Accountant's sheet",
  "وعد": "Promise",
  "وعد بالسداد": "Promised to pay",
  "وعدٌ بالسداد": "Promise to pay",
  "يناير": "January",
  "ينتهي اليوم": "Ends today",
  "ينتهي بعد": "Ends in",
  "يوليو": "July",
  "يوم صرف جهة العمل": "Employer payday",
  "يومٌ ثابت": "Fixed day",
  "يومٌ ثابت يدويّ": "Manual fixed day",
  "يومُ صرف الجهة": "Employer payday",
  "يومُ صرف جهة العمل": "Employer payday",
  "يونيو": "June",
  "يُنشأ رابطٌ بقيمة المتبقّي ويُضاف آخرَ الرسالة": "A link for the remaining amount is created and appended to the message",
  "▶ تشغيل التسجيل": "▶ Play recording",
  "⚠ شهريّ في Drive8": "⚠ Monthly in Drive8",
  "قبول الرحلة": "Accept trip",
  "انطلقت إلى نقطة الاستلام": "On my way to pickup",
  "وصلت لنقطة الاستلام": "Arrived at pickup",
  "بدء الرحلة (الراكب صعد)": "Start trip (passenger on board)",
  "وصلت للوجهة": "Arrived at destination",
  "إنهاء الرحلة": "Complete trip",
  "مجدول": "Scheduled",
  "مُسند — بانتظار القبول": "Assigned — awaiting acceptance",
  "قبِل السائق": "Driver accepted",
  "في الطريق للاستلام": "En route to pickup",
  "وصل — بانتظار الراكب": "Arrived — waiting for passenger",
  "الرحلة جارية": "Trip in progress",
  "وصل للوجهة": "At destination",
  "لم يحضر": "No-show",
  "اسمح للموقع بالوصول للموقع (GPS) من إعدادات المتصفح": "Allow location (GPS) access in your browser settings",
  "الاستلام": "Pickup",
  "الانتظار": "Waiting",
  "المنتهية اليوم ({n})": "Finished today ({n})",
  "المهلة {n} دقائق": "Grace period {n} min",
  "الوجهة": "Destination",
  "تجاوز مهلة الانتظار": "Waiting grace period exceeded",
  "تعذّر تحديد موقعك — تأكد أن GPS شغّال": "Couldn't get your location — make sure GPS is on",
  "تم تسجيل الوصول — {s}": "Arrival recorded — {s}",
  "تم ✓": "Done ✓",
  "جوالك لا يدعم تحديد الموقع": "Your phone doesn't support location",
  "خرائط": "Maps",
  "رحلاتي": "My Trips",
  "زر 📍 يرسل موقع جوالك — لازم تكون ضمن {n} م من النقطة.": "The 📍 button sends your phone's location — you must be within {n} m of the point.",
  "في الوقت": "On time",
  "ما عندك رحلات حالياً.": "You have no trips right now.",
  "مبكر": "Early",
  "متأخر {n} د": "Late {n} min",
  "ذكاءٌ على السيرفر يقترح ردوداً على العملاء — الموظّف يراجع قبل الإرسال": "Server-side AI suggests replies to customers — staff review before sending",
  "الرد المقترح في صندوق الوارد": "Suggested reply in Inbox",
  "يظهر فوق خانة الكتابة عند فتح محادثةٍ آخرُ رسالةٍ فيها من العميل. لا يُرسَل شيءٌ إلا بضغطة موظّف.": "Appears above the composer when you open a conversation whose last message is from the customer. Nothing is sent without a staff click.",
  "مطفأ": "Off",
  "النموذج": "Model",
  "الجودة — آخر ٣٠ يوماً": "Quality — last 30 days",
  "اقتراحات": "Suggestions",
  "أُرسل كما هو": "Sent as is",
  "عُدِّل": "Edited",
  "تُجوهل": "Dismissed",
  "متوسّط الوقت": "Avg. time",
  "نسبة القبول بلا تعديل": "Acceptance rate without edits",
  "من الاقتراحات التي قرّر فيها موظّف. فوق ٨٠٪ لأسبوعين = جاهزٌ للمرحلة ٢.": "Of suggestions a staff member acted on. Above 80% for two weeks = ready for phase 2.",
  "جرّبه كأنّك عميل": "Try it as a customer",
  "لا يُكتب شيءٌ في المحادثات — التجربة هنا فقط.": "Nothing is written to conversations — testing happens here only.",
  "اكتب رسالة العميل…": "Type the customer's message…",
  "أرسل كعميل": "Send as customer",
  "مسح": "Clear",
  "يكتب الرد…": "Writing reply…",
  "في الطابور": "In queue",
  "تعذّر الرد": "Reply failed",
  "الرد المقترح": "Suggested reply",
  "آخر الردود التي عدّلها الموظفون": "Latest replies edited by staff",
  "هذه أفضل مادةٍ لتحسينه: أضِف الصحيحَ منها إلى «قاعدة المعرفة».": "This is the best material to improve it: add the correct ones to the Knowledge Base.",
  "اقتُرح": "Suggested",
  "أُرسل": "Sent",
  "لا شيء بعد": "Nothing yet",
  "الراكب": "Passenger",
  "المريض": "Patient",
  "الشحنة": "Shipment",
};
export default EN_B7;
